module.exports = __webpack_public_path__ + "img/adopting-IN.fe813fef.png";